import { sectionContainerAtom } from '@ingenico/react-section-utils';
import { createStore, Provider } from 'jotai';
import { memo, useMemo, type ReactElement } from 'react';
import { deviceManagementContainer } from '../../container.const';
import deepEqual from 'fast-deep-equal';
import { ProvisioningDeviceChangeDetailsPage } from '../../pages/provisioning-device-change-details-page/ProvisioningDeviceChangeDetailsPage.ctrl';

export function ExposedProvisioningDeviceChangeDetailsDrawerComponent(): ReactElement {
  // Pre-initialize the section container on a fresh store before any child renders, because
  // when loading from another section like provisioning, the component will try to get access
  // to the configuration business service which lives in the device management section.
  // @ingenico/react-section-utils reads sectionContainerAtom synchronously during render and
  // throws if it is null, so the value must be set before the Provider mounts its children.
  const store = useMemo(() => {
    const sectionStore = createStore();
    sectionStore.set(sectionContainerAtom, deviceManagementContainer);
    return sectionStore;
  }, []);

  return (
    <Provider store={store}>
      <ProvisioningDeviceChangeDetailsPage />
    </Provider>
  );
}

export const ExposedProvisioningDeviceChangeDetailsDrawer = memo(
  ExposedProvisioningDeviceChangeDetailsDrawerComponent,
  deepEqual,
);
